<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Region</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'active') || (field.name === 'countryIsoCode' && editMode)"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'countryIsoCode') && editMode">
              <input class="checkbox" v-else-if="field.name === 'active'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Region' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {Region} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'RegionEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        countryIsoCode : this.$route.params.countryIsoCode,
        region : this.$route.params.region,
      },
      editMode: false,
      fields: [
        { name: "countryIsoCode", label: "Country ISO code" },
        { name: "region", label: "Region" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.countryIsoCode) {
      this.editMode = true;
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new Region(
          this.editedConfig.countryIsoCode,
          this.editedConfig.region
      );

      if (dataToSave.countryIsoCode == "") {
        alert('Country ISO code is required');
      } else {
        if (this.editMode) {
          // Editing an existing configuration
          AdminService.updateRegion(dataToSave).then(() => {
            alert('Update complete');
            // Redirect to the page
            this.$router.push({ name: 'Regions' });
          }).catch((error) => {
            if (error.response && error.response.data && error.response.data.message) {
              alert(error.response.data.message);
            }
          });
        } else {
          AdminService.insertRegion(dataToSave).then(() => {
            alert('Insert complete');
            // Redirect to the page
            this.$router.push({ name: 'Regions' });
          }).catch((error) => {
            this.error = error.message
          });
        }
      }
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
